'use strict';

angular.module('TurneroApp').component('coBloqueoatencion', {
    bindings: {
        centroAtencionSeleccionado: '<',
    },
    controller: [
		 'bloqueoCalendarioService',
		 '$anchorScroll',
		 'turnosService',
		 'agendaService',
		 'utilsService',
		 'TurneroAppConstant',
		 function (bloqueoCalendarioService, $anchorScroll, turnosService, agendaService, utilsService, TurneroAppConstant) {
             var ctrl = this;

             ctrl.showfiltro = true;
             ctrl.bloqueoConsultar = true;
             ctrl.bloqueoCrear = false;
             ctrl.permisos = TurneroAppConstant.Permisos;

             //ctrl.$onInit = function () {
             //    ctrl.getConsultaInfo();
             //}

             //el onChange se ejecuta cada vez que cambian los parametros del binding 
             ctrl.$onChanges = function () {
                 if (ctrl.centroAtencionSeleccionado.id) {
                     ctrl.getConsultaInfo();
                 }
             }

             ctrl.limpiarMemoria = function () {
                 ctrl.bloqueoConsultar = false;
                 ctrl.bloqueoCrear = false;
		         ctrl.bloqueoConsulta_Resultado = [];
                 ctrl.showfiltro = true;

		         $anchorScroll();
		     }

		     ctrl.getConsultaInfo = function () {
		         ctrl.loadFiltros();
		         ctrl.limpiarMemoria();
		         ctrl.cargarGrilla();
                 ctrl.bloqueoConsultar = true;
		     }

		     ctrl.limitOptions = [10, 25, 50, 75, 100, {
		         label: 'Todos',
		         value: function () {
		             return ctrl.pagination.total;
		         }
		     }];

		     ctrl.query = {
		         limit: 10,
		         page: 1,
		         filter: ''
		     };

		     //Se inicializa en null para que al principio no tome que no hay valores
		     ctrl.pagination = {
		         total: null
		     };
             
		     ctrl.filter = false;

		     ctrl.removeFilter = function () {
		         ctrl.grillaReload();
		         ctrl.filter = false;
		     };
             
		     ctrl.desactivarBloqueo = function (item) {
                 bloqueoCalendarioService.Post_Desbloqueo_Calendario({
                     'id_bloqueo': item.Id_Bloqueo_Calendario
                 }).$promise.then(function (result) {
		             if (result.Data && result.Data != 'null') {
		                 swal({
		                     title: 'Información',
		                     html: result.Data,
		                     type: 'info',
		                     showCancelButton: false,
		                     confirmButtonColor: '#004b81',
		                     confirmButtonText: 'Aceptar'
		                 }).then(function () {
		                     ctrl.getConsultaInfo();
		                 })
		             } else {
		                 swal({
		                     title: 'Desactivado!',
		                     html: 'El bloqueo de atención ha sido desactivado correctamente.',
		                     type: 'success',
		                     showCancelButton: false,
		                     confirmButtonColor: '#004b81',
		                     confirmButtonText: 'Aceptar'
		                 }).then(function () {
		                     ctrl.getConsultaInfo();
		                 })
		             }

		         }).catch(function (error) {
		             utilsService.errores(error);
		         });

		     }

		     ctrl.inicializarAltaBloqueo = function () {
                 ctrl.limpiarMemoria();
                 ctrl.bloqueoCrear = true;

		         ctrl.tLoadAlta();
             }

		     ctrl.loadFiltros = function () {
		         utilsService.swalTitle('Cargando datos', 'info')
                 bloqueoCalendarioService.Get_Bloqueo_Calendario_Historial_Filtro({
                     'id_centro_atencion': ctrl.centroAtencionSeleccionado.id
                 }).$promise.then(function (resultado) {
		             ctrl.Filtros = resultado.Data
		             swal.close()
		         }).catch(function (error) {
		             utilsService.errores(error);
		         });

		     }

		     ctrl.cargarGrilla = function () {
		         utilsService.swalTitle('Cargando datos', 'info')
		         ctrl.getData(ctrl.query.page, ctrl.query.limit, 'grid', cargarDatos)
		     }

		     ctrl.getData = function (page, limit, tipo, callback) {
		         ctrl.promise = bloqueoCalendarioService.Get_Bloqueo_Calendario_Historial({
		             'filtro.Id_Centro_Atencion': ctrl.centroAtencionSeleccionado.id,
		             'filtro.Id_Agenda': ctrl.query.Id_Agenda,
		             'filtro.Id_Estado': ctrl.query.Id_Estado,
		             'filtro.Nro_Pagina': page,
		             'filtro.Tam_Pagina': limit
		         }).$promise.then(function (resultado) {
		             callback(tipo, resultado)
		         }).catch(function (error) {
		             utilsService.errores(error);
		         });;

		     }

		     function cargarDatos(tipo, data) {
		         if (tipo == 'grid') {
		             ctrl.bloqueoConsulta_Resultado = data.Data;
		             ctrl.pagination.total = data.Paging.Reg_Totales;
		             swal.close();
		         } else if (tipo == 'xls') {
		             var arrayObjeto = data.Data;
		             ctrl.arrayExport = [];
		             ctrl.arrayExport[0] = ['Agenda', 'Fecha Desde', 'Fecha Hasta', 'Hora Desde', 'Hora Hasta', 'Motivo', 'Estado'];
		             for (var i = 0; i < arrayObjeto.length; i++) {

		                 ctrl.arrayExport[i + 1] = [
                              arrayObjeto[i].N_Agenda,
                              moment(arrayObjeto[i].Fec_Desde).toDate().toLocaleDateString(),
                              moment(arrayObjeto[i].Fec_Hasta).toDate().toLocaleDateString(),
                              arrayObjeto[i].Hora_Desde,
                              arrayObjeto[i].Hora_Hasta,
                              arrayObjeto[i].N_Motivo,
                              arrayObjeto[i].N_Estado,
		                 ]
		             }
		             swal.close();
		             ctrl.Excel.down([{
		                 name: 'Bloqueos_de_atencion',
		                 data: ctrl.arrayExport
		             }]);
		         }
		     }

		     ctrl.isOpen = false;
		     ctrl.selectedMode = 'md-fling';
		     ctrl.selectedDirection = 'up';

		     ctrl.exportar = function (tipo) {
		         utilsService.swalTitle('Exportando datos', 'info')
		         ctrl.arrayExport = [];
		         ctrl.getData(1, ctrl.pagination.total, tipo, cargarDatos)

		     }
		     ctrl.Excel = {
		         down: function () {
		         },
		     }
		 }
    ],
    template: require('./consultaBloqueo.html')
});



// WEBPACK FOOTER //
// ./app/components/supervision/Bloqueo_Atencion/bloqueoAtencionComponent.js